import { createFileRoute } from '@tanstack/react-router'

import { Overview } from '@/components/Overview'
import { withTitle } from '@/utils/withTitle.ts'

export const Route = createFileRoute('/_app/')({
  component: IndexPage,
  head: withTitle('Overview'),
})

function IndexPage() {
  return <Overview />
  // return (
  //   <Stack
  //     //h={300}
  //     bg="var(--mantine-color-body)"
  //     align="stretch"
  //     justify="flex-start"
  //     gap="md"
  //   >
  //     <Overview />
  //   </Stack>
  // )
}
